
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Singlesharingpginhinjewadiformalefemale() {



    const cardData =
    {
        keyword: 'Single Sharing PG in Hinjewadi for Male & Female ',
        heading: 'Shree Swami Samarth PG: Single Sharing PG in Hinjewadi for Male & Female',
        headingDescription: 'Shree Swami Samarth PG provides comfortable and affordable single sharing PG in Hinjewadi for both male and female residents, offering privacy, safety, and modern amenities for a homely stay. Our single occupancy rooms are fully furnished with cozy bedding, study/work areas, wardrobes, and proper ventilation, making them ideal for students and working professionals who prefer independent living. Located close to major IT parks, colleges, and residential hubs in Hinjewadi, our PG ensures easy connectivity to offices like Infosys, Wipro, Cognizant, and educational institutes. Residents enjoy hygienic home-cooked meals, high-speed WiFi, 24x7 water supply, CCTV surveillance, and regular housekeeping, ensuring a secure and hassle-free lifestyle. With disciplined management, peaceful surroundings, and budget-friendly rent plans, Shree Swami Samarth PG’s single sharing accommodation in Hinjewadi is the perfect choice for both men and women seeking comfort, convenience, and independence.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Private Single-Occupancy Rooms",
    "description": "PGs in Hinjewadi offer private single rooms designed for both males and females, ensuring privacy and peaceful living. These rooms typically come furnished with a comfortable bed, wardrobe, study desk, and chair. Some even include air-conditioning, attached bathrooms, and balconies for added comfort. Ideal for students and professionals alike, the layout is both functional and cozy. Many listings specifically highlight single occupancy options, reflecting their popularity and demand in the area."
  },
  {
    "title": "Inclusive Meal Options",
    "description": "Many single-sharing PGs in Hinjewadi include meals such as breakfast, lunch, and dinner as part of the rent package. The kitchens usually maintain high hygiene standards, with some providing home-style or regional menus. This meal-inclusive setup saves residents time and effort while ensuring nutritious, hassle-free living. Ideal for busy professionals or students, it streamlines daily routines, making the stay more convenient and healthy."
  },
  {
    "title": "High-Speed Wi-Fi & Power Backup",
    "description": "Reliable high-speed Wi-Fi is a standard offering across most PGs in Hinjewadi, supporting uninterrupted work-from-home, streaming, and gaming needs. Many properties also offer uninterrupted power backup, which is especially useful during scheduled outages, ensuring there’s no disruption to work or study sessions. This combination of internet and electricity reliability is particularly attractive to IT professionals who require stable connectivity."
  },
  {
    "title": "Secure & Gender-Inclusive Access",
    "description": "These PGs prioritize safety, offering CCTV surveillance, secure entry systems, and regulated visitor access. Many are unisex-friendly—welcoming both males and females—while ensuring well-maintained communal standards and respectful environments. Secure neighborhoods and friendly staff enhance peace of mind, making single rooms a comfortable choice for all residents."
  },
  {
    "title": "Close Proximity to Hinjewadi IT Parks",
    "description": "Located conveniently near Hinjewadi IT Park and major corporations like Infosys and Wipro, many of these PGs minimize commuting time. This proximity enhances work-life balance, keeping daily travels stress-free. Additionally, the neighborhood is well-connected with transport options, local shops, and eateries, making them practical for daily errands."
  },
  {
    "title": "Housekeeping and Laundry Facilities",
    "description": "To streamline living, these PGs often include daily or regular housekeeping services that keep rooms and common areas clean and hygienic. Laundry options—either in-house or through local vendors—are often available, easing the burden of chores. This level of convenience allows residents to focus on their academics or careers without worrying about maintenance tasks."
  },
  {
    "title": "Flexible & Transparent Pricing",
    "description": "Single-occupancy PGs in Hinjewadi start around ₹10,000/month and can go up to ₹13,600/month for AC rooms, depending on amenities and setup. Some co-living platforms like Zolo even offer single rooms starting as low as ₹3,000–₹5,000/month. Prices often include essential features such as meals, Wi-Fi, housekeeping, and security. Many providers maintain transparent pricing with no hidden costs, allowing residents to plan finances confidently."
  },
  {
    "title": "Co-living Options with Community Vibe",
    "description": "Several PGs are managed by branded co-living platforms like Tribe and Zolo, offering a mix of private rooms and shared community spaces. These listings often include well-designed common areas, events, and wellness zones—creating a sense of belonging. While offering privacy in single rooms, they also promote social interaction and a balanced lifestyle among professionals and students."
  }
],


"services": [
  {
    "name": "Single Sharing PG in Hinjewadi",
    "description": "Shree Swami Samarth PG offers single sharing PG options in Hinjewadi, designed for individuals who value their space and peace. Each room is fully furnished with an attached washroom, work desk, and wardrobe, ensuring privacy and comfort for working professionals and students alike."
  },
  {
    "name": "1-Seater PG in Hinjewadi",
    "description": "Looking for a 1-seater PG in Hinjewadi? Our private room PGs come with AC, Wi-Fi, daily housekeeping, and fresh meals. Ideal for employees working in TCS, Infosys, or nearby tech parks, this option ensures uninterrupted work and restful downtime."
  },
  {
    "name": "Private Room PG for Male in Hinjewadi",
    "description": "Shree Swami Samarth PG provides dedicated private room PGs for male professionals in Hinjewadi. Enjoy a secure and well-furnished space equipped with AC, high-speed internet, personal washroom, and home-cooked meals—just minutes away from top companies."
  },
  {
    "name": "Private Room PG for Female in Hinjewadi",
    "description": "Our private PG rooms for female tenants offer a perfect blend of security, cleanliness, and convenience. With female-only floors, 24/7 CCTV, and female staff support, Shree Swami Samarth PG is an ideal choice for working women and students near Hinjewadi Phase 1, 2, and 3."
  },
  {
    "name": "Non-Sharing PG in Hinjewadi",
    "description": "If you prefer not to share your space, Shree Swami Samarth PG offers non-sharing PG rooms with premium features. Each room includes AC, private bathroom, storage, Wi-Fi, and a meal plan, providing a quiet and private lifestyle for focused professionals."
  },
  {
    "name": "Individual Room PG in Hinjewadi",
    "description": "Our individual room PGs are perfect for solo residents who value independence and quiet. With elegant interiors, attached amenities, and a peaceful living atmosphere, these rooms are tailored for IT employees, remote workers, and corporate interns in Hinjewadi."
  },
  {
    "name": "AC Single Sharing PG Hinjewadi",
    "description": "Stay cool and comfortable with our AC single sharing PG in Hinjewadi. Shree Swami Samarth PG ensures high-quality living with air-conditioned rooms, hygienic food, regular cleaning, and proximity to Blue Ridge, Megapolis, and other office hubs."
  },
  {
    "name": "Premium Single Room PG for Working Professionals",
    "description": "Upgrade your living standard with our premium single occupancy PG in Hinjewadi. Designed for working professionals, these rooms offer complete privacy, attached washrooms, modern interiors, AC, fast Wi-Fi, and meals—delivering a hassle-free stay near your workplace."
  },
  {
    "name": "Boys & Girls PG with Single Occupancy in Hinjewadi",
    "description": "Whether you're a male or female tenant, Shree Swami Samarth PG offers gender-specific single occupancy PG options in Hinjewadi. Choose from furnished rooms with individual setups, food service, daily cleaning, and easy access to Hinjewadi Phases 1, 2, and 3."
  }
],
"tableData": [
  ["Single Sharing PG in Hinjewadi", "1-Seater PG in Hinjewadi"],
  ["Private Room PG for Male in Hinjewadi", "Private Room PG for Female in Hinjewadi"],
  ["Non-Sharing PG in Hinjewadi", "Individual Room PG in Hinjewadi"],
  ["AC Single Sharing PG Hinjewadi", "Premium Single Room PG for Working Professionals"],
  ["Boys & Girls PG with Single Occupancy in Hinjewadi", ""]
],




"whychoose": [
    {
        "WhyChooseheading": "Single Sharing PG in Hinjewadi for Male & Female",
        "WhyChoosedescription": "Shree Swami Samarth PG offers private, single-sharing rooms for both male and female residents in the heart of Hinjewadi. Designed for comfort, privacy, and productivity, it's an ideal stay option for working professionals, interns, and students who prefer personal space and peace."
    },
    {
        "WhyChooseheading": "Spacious Private Rooms with Premium Furnishings",
        "WhyChoosedescription": "Each single occupancy room is fully furnished with a personal bed, wardrobe, study desk, attached bathroom, and high-speed Wi-Fi. Air-conditioned options are also available to ensure maximum comfort, especially during long workdays or study hours."
    },
    {
        "WhyChooseheading": "Ideal for Both Male and Female Professionals",
        "WhyChoosedescription": "Whether you're a software engineer, MBA student, or corporate intern, our PG welcomes both men and women in separate wings—ensuring a respectful, gender-sensitive, and well-managed living environment with zero compromise on privacy."
    },
    {
        "WhyChooseheading": "Healthy, Home-Cooked Meals Included",
        "WhyChoosedescription": "Enjoy nutritious and freshly prepared meals served three times a day. Our kitchen staff follows strict hygiene practices, and meals are balanced to support your health and energy—perfect for those with demanding work or study schedules."
    },
    {
        "WhyChooseheading": "Strategic Location Near Major IT Companies",
        "WhyChoosedescription": "Located close to Infosys, Wipro, Cognizant, TCS, and Tech Mahindra, our PG cuts down on commute time significantly. With easy access to Phases 1, 2, and 3 of Hinjewadi, you’ll never be far from work or transit hubs."
    },
    {
        "WhyChooseheading": "Safety, Security & Cleanliness Assured",
        "WhyChoosedescription": "Our PG offers 24/7 security with CCTV cameras, biometric access, separate entries for male and female residents, and regular housekeeping. Clean and sanitized rooms are maintained consistently to ensure a safe and hygienic stay."
    },
    {
        "WhyChooseheading": "All-Inclusive Rent with Flexible Plans",
        "WhyChoosedescription": "Our single-sharing packages include everything—accommodation, food, electricity, laundry, Wi-Fi, and housekeeping. No brokerage, no hidden fees. Monthly, quarterly, and custom short-term plans are also available for flexibility."
    },
    {
        "WhyChooseheading": "Perfect for Focused Living and WFH",
        "WhyChoosedescription": "Need quiet space to work or study? Our single-sharing PG setup is perfect for remote work, long study hours, or simply relaxing alone after a hectic day. Enjoy complete freedom in a peaceful co-living atmosphere designed for individual comfort."
    }
]






















    }
    
const faqData = [
    {
        question: "How can I book a single sharing PG in Hinjewadi for male and female at Shree Swami Samarth PG?",
        answer: "You can book a single occupancy room by calling us at +91 9594917913. We also provide assistance with online booking and virtual property tours."
    },
    {
        question: "Do you provide separate single sharing PGs for males and females?",
        answer: "Yes, we have dedicated wings and buildings for male and female residents to ensure safety, privacy, and comfort for all."
    },
    {
        question: "What facilities are included in single sharing rooms at your PG in Hinjewadi?",
        answer: "Each single occupancy room is fully furnished with a bed, wardrobe, study table, private bathroom (in most units), high-speed Wi-Fi, and daily housekeeping."
    },
    {
        question: "Is food included in the single sharing PG rent?",
        answer: "Yes, all residents receive freshly prepared, hygienic vegetarian meals—served three times a day."
    },
    {
        question: "Is your PG safe for single male and female residents?",
        answer: "Absolutely. Our PG is secured with 24/7 CCTV surveillance, biometric access, restricted visitor entry, and on-site staff support."
    },
    {
        question: "Are the single sharing rooms air-conditioned?",
        answer: "Yes, we offer both A/C and non-A/C single rooms to match your budget and preferences."
    },
    {
        question: "Is the PG near IT offices and colleges in Hinjewadi?",
        answer: "Yes, we are located close to major tech parks like Infosys, Wipro, TCS, and educational institutions for easy daily commute."
    },
    {
        question: "What is the monthly rent for a single sharing PG in Hinjewadi?",
        answer: "The rent depends on room type (A/C or non-A/C) and amenities. Contact us for the most accurate pricing and current offers."
    },
    {
        question: "Is there a minimum stay period required for single sharing rooms?",
        answer: "Yes, the minimum stay is typically one month. Long-term stays are welcome and may come with discounted rates."
    },
    {
        question: "How do I contact Shree Swami Samarth PG to book a single sharing PG in Hinjewadi?",
        answer: "Simply call us at +91 9594917913 to check availability, get pricing, or schedule a property visit."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sagar Kulkarni',
        designation: 'System Analyst, Infosys Hinjewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“I stayed in a single occupancy room and it was totally worth it. Clean, peaceful, and very well-managed PG in Hinjewadi.”',
    },
    {
        name: 'Ms. Sneha Jagtap',
        designation: 'MBA Student, Symbiosis Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“Perfect place for girls looking for a single room PG in Hinjewadi. Safe, neat, and food is just like home!”',
    },
];



























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Single Sharing PG in Hinjewadi for Male & Female",
  "image": "https://swamisamarthpg.com/assets/images/single-sharing-pg-hinjewadi.jpg", // Replace with actual image URL
  "description": "Premium single sharing PG accommodations in Hinjewadi for both male and female residents. Featuring private AC rooms, ideal for working professionals seeking comfort and privacy.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1850"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10200",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/single-sharing-pg-hinjewadi"  // Replace with actual page URL if different
  }
};





    return (
        <div>
<Helmet>
  <title>Single Sharing PG in Hinjewadi for Male & Female | Private Rooms</title>
  <meta 
    name="description" 
    content="Find premium single sharing PG in Hinjewadi with private AC rooms for male and female working professionals. Enjoy privacy and comfort with individual occupancy." 
  />
  <meta 
    name="keywords" 
    content="Single Sharing PG in Hinjewadi, 1-Seater PG in Hinjewadi, Private Room PG for Male in Hinjewadi, Private Room PG for Female in Hinjewadi, Non-Sharing PG in Hinjewadi, Individual Room PG in Hinjewadi, AC Single Sharing PG Hinjewadi, Premium Single Room PG for Working Professionals, Boys & Girls PG with Single Occupancy in Hinjewadi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/24.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Singlesharingpginhinjewadiformalefemale;